
// wrapper for Websql & cordova sqlite plugin

export default class Local{
    
    constructor(options){

      this.name="Local";
      this.options=options;
      //this.db;
      //this.db_manager; // the plugin or function on window
      //this.data=[];

    }

    openDatabase(){

      return Promise.resolve();

    }    

    createTable(){
      return Promise.resolve();
    }
    parseDatabase(){
      return Promise.resolve();
    }


    setItem(key,val){
        
      localStorage.setItem(key,val)
    
    }
    
    // get item from storage by key
    getItem(key){

      return localStorage.getItem(key)
      
    }
    
    clear(){
      localStorage.clear();
    }
    
   // print out the stored information 
   print(){
      
    }





    
  }
